import React, { useContext, useState } from 'react';
import { ModuleType } from 'infrastructure/enums';

interface IContextProps {
  module: ModuleType;
  changeModule: (module: ModuleType) => void;
}

const ModuleContext = React.createContext<IContextProps | undefined>(undefined);

export const useModule = (defaultModule = ModuleType.RPM) => {
  const context = useContext(ModuleContext);
  if (!context) {
    const [module, setModule] = useState(defaultModule);
    return {
      module,
      changeModule: setModule,
    };
  }

  return context;
};

interface IProps {
  children?: React.ReactNode;
}

const ModuleProvider: React.FC<IProps> = ({ children }) => {
  const [module, setModule] = useState(ModuleType.RPM);

  return (
    <ModuleContext.Provider
      value={{
        module,
        changeModule: setModule,
      }}
    >
      {children}
    </ModuleContext.Provider>
  );
};

export default ModuleProvider;
